function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import applyUrlParams from '@signal/utils/applyUrlParams';
export var ResponsiveImage = /*#__PURE__*/memo(function (_ref) {
  var renderImage = _ref.children,
      Image = _ref.component,
      srcSetProp = _ref.srcSet,
      width = _ref.width,
      alt = _ref.alt,
      rest = _objectWithoutProperties(_ref, ["children", "component", "srcSet", "width", "alt"]);

  var defaultOpts = Object.assign({
    auto: 'format'
  }, width && {
    w: width
  }); // Browsers that lack `srcSet` support will fallback to the `src` attribute
  // instead, so it's important that we provide it a value. Because it's the
  // smallest, I chose the image from the `srcSet` that targets devices with
  // a `dpr` (device pixel ratio) of 1.

  var baseImg = srcSetProp.find(function (_ref2) {
    var dpr = _ref2.dpr;
    return dpr === 1;
  });
  var src = applyUrlParams(baseImg.src, defaultOpts);
  var srcSet = srcSetProp.map(function (_ref3) {
    var dpr = _ref3.dpr,
        src = _ref3.src;
    var opts = dpr > 1 ? _objectSpread(_objectSpread({}, defaultOpts), {}, {
      dpr: dpr
    }) : defaultOpts;
    return "".concat(applyUrlParams(src, opts), " ").concat(dpr, "x");
  }).join(',');
  if (renderImage) return renderImage(_objectSpread({
    src: src,
    srcSet: srcSet,
    width: width,
    alt: alt
  }, rest));
  return /*#__PURE__*/React.createElement(Image, Object.assign({
    src: src,
    srcSet: srcSet,
    width: width,
    alt: alt
  }, rest));
});
ResponsiveImage.propTypes = {
  /**
   * A render prop can be used as `children` to support more use-cases.
   * @type {Function}
   */
  children: PropTypes.func,
  component: PropTypes.node,
  srcSet: PropTypes.arrayOf(PropTypes.shape({
    dpr: PropTypes.number.isRequired,
    src: PropTypes.string.isRequired
  })).isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number
};
ResponsiveImage.defaultProps = {
  component: 'img'
};
export default ResponsiveImage;